
import React from 'react';

const ServiceDescription: React.FC = () => {
  return (
    <section className="section-padding bg-white">
      <div className="container-wide">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div>
            <h2 className="heading-lg text-itmgmt-dark-blue mb-6">Network & Infrastructure Services</h2>
            <p className="text-lg text-gray-600 mb-8">
              A reliable network infrastructure is the backbone of your business. We design, implement, 
              and manage secure, scalable network solutions that provide the performance and reliability 
              your business needs.
            </p>
            
            <div className="space-y-6">
              <div className="bg-itmgmt-light-gray p-6 rounded-lg">
                <h3 className="font-bold text-itmgmt-dark-blue text-xl mb-3">Core Network Services</h3>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                    <span>Firewall & Wi-Fi Configuration</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                    <span>Structured Cabling & Network Design</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                    <span>NAS File Server Setup</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                    <span>Active Directory Management</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                    <span>VLAN & Port Management</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                    <span>Secure Guest Wi-Fi Portals</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          
          <div>
            <h2 className="heading-lg text-itmgmt-dark-blue mb-6">Benefits of Professional Network Solutions</h2>
            <div className="space-y-6">
              <div className="flex">
                <div className="bg-itmgmt-medium-blue rounded-full h-10 w-10 flex items-center justify-center shrink-0 mr-4">
                  <span className="text-white font-bold">1</span>
                </div>
                <div>
                  <h3 className="font-bold text-itmgmt-dark-blue text-lg mb-2">Enhanced Performance</h3>
                  <p className="text-gray-600">
                    Optimized network design that eliminates bottlenecks and ensures consistent connectivity for all users.
                  </p>
                </div>
              </div>
              
              <div className="flex">
                <div className="bg-itmgmt-medium-blue rounded-full h-10 w-10 flex items-center justify-center shrink-0 mr-4">
                  <span className="text-white font-bold">2</span>
                </div>
                <div>
                  <h3 className="font-bold text-itmgmt-dark-blue text-lg mb-2">Improved Security</h3>
                  <p className="text-gray-600">
                    Properly configured firewalls, segmented networks, and secure access controls to protect against threats.
                  </p>
                </div>
              </div>
              
              <div className="flex">
                <div className="bg-itmgmt-medium-blue rounded-full h-10 w-10 flex items-center justify-center shrink-0 mr-4">
                  <span className="text-white font-bold">3</span>
                </div>
                <div>
                  <h3 className="font-bold text-itmgmt-dark-blue text-lg mb-2">Scalability</h3>
                  <p className="text-gray-600">
                    Future-proof infrastructure that grows with your business without requiring complete redesigns.
                  </p>
                </div>
              </div>
              
              <div className="flex">
                <div className="bg-itmgmt-medium-blue rounded-full h-10 w-10 flex items-center justify-center shrink-0 mr-4">
                  <span className="text-white font-bold">4</span>
                </div>
                <div>
                  <h3 className="font-bold text-itmgmt-dark-blue text-lg mb-2">Reliability</h3>
                  <p className="text-gray-600">
                    Redundant systems and proper configuration to minimize downtime and ensure business continuity.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceDescription;
